<template>
  <div>
    <table class="table mt-1 table-hover table-sm">
      <thead>
      <tr>
        <th></th>
        <th>Заявка</th>
        <th>Сообщение</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, i) in ([...errors, ...pass])" :class="{'bg-warning': !!r.message}">
        <td>{{ i + 1 }}</td>
        <td>
          <template v-if="r.order_id">
            <button
              @click="openOrderToEdit(r.order_id)"
              class="btn btn-xs btn-info ml-1 mr-2"
            >
              <i class="icon-fa icon-fa-eye"></i>
            </button>
            {{ r.order_id }}
          </template>
        </td>
        <td>
          <p>{{ r.message }}</p>
          <p>{{ r.index }}</p>
        </td>
        <td>
          <p>тел: {{ r.phone }}</p>
          <p>{{ r.address }}</p>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: ['pass', 'errors']
}

</script>
